module.exports = __webpack_public_path__ + "media/images/banner-cs@2x-216135b7a2edf7d7a94a179d4bdb389b.png";